// Dependencies
import {
  PROVEEDORES_REQUEST,
  PROVEEDORES_OK,
  PROVEEDORES_REFRESH,
  PROVEEDORES_ERROR,
} from "./types";

const initialState = {
  qty: null,
  data: [],
  loading: false,
  error: false,
  refreshing: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PROVEEDORES_REQUEST:
      return { ...state, loading: true };
    case PROVEEDORES_REFRESH:
      return { ...state, refreshing: true };
    case PROVEEDORES_ERROR:
      return {
        ...state,
        loading: false,
        refreshing: false,
        error: action.payload.error,
      };
    case PROVEEDORES_OK:
      return {
        ...state,
        loading: false,
        refreshing: false,
        data: action.payload.data,
        qty: action.payload.qty,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
